import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Path 1783" d="M14.744 4.256l5 5L5 24H0v-5zm6.426 3.573l-5-5 2.44-2.44a1.328 1.328 0 011.88 0l3.12 3.12a1.328 1.328 0 010 1.88z" fill="#1791dd" /></svg>);